import React, {Component} from "react";
import PropTypes from "prop-types";
import "../../styles/PaySlipFormStyles.css";
import i18next from "i18next";

class PaySlipFormSlavutich extends Component {
    constructor(props, context) {
        super(props, context);

        this.headersHdr = this.props.headerDataItem.rawData.ResultFieldInfo.reduce((r, fi) => {
            r[fi.Name] = fi.Title;
            return r;
        }, {});

        this.headersTab = this.props.tableDataItem.rawData.ResultFieldInfo.reduce((r, fi) => {
            r[fi.Name] = fi.Title;
            return r;
        }, {});
    }

    getHeader = (name, area = 'header') => {
        let source = area === 'table' ? this.headersTab : this.headersHdr;
        if (source && source[name]) {
            return source[name].replace("|", " ");
        }
    }

    getMoneyValue = (value) => {
        const nf = new Intl.NumberFormat( {maximumFractionDigits:2});
        return value ? nf.format(value) : <>&nbsp;</>
    }

    renderHeaderInfo = (level1Info) => {
        console.log(`level1Info: ${JSON.stringify(level1Info)}`);
        return (
            <div id="paySlip_header">
                <h3>{i18next.t('PaySlip')}</h3>
                <table id="paySlip_header1" cellPadding="3">
                        <table id="header1" cellPadding="3">
                            <tbody>
                            <tr>
                                <td colSpan="2" className="font-weight-bold">{i18next.t("PaySlip_Slavutich_1")} {level1Info.CalcMonth}</td>
                                <td className="text-left">{i18next.t("PaySlip_Slavutich_2")}</td>
                                <td colSpan="3" className="font-weight-bold">{level1Info.Tarif} {i18next.t("PaySlip_Slavutich_6")}</td>
                            </tr>
                            <tr>
                                <td>{i18next.t("PaySlip_Slavutich_7")}</td>
                                <td className="font-weight-bold">({level1Info.AsCode}) {level1Info.AsName}</td>
                                <td className="text-left">{i18next.t("PaySlip_Slavutich_3")}</td>
                                <td className="font-weight-bold">{this.getMoneyValue(level1Info.Salary)} {i18next.t("PaySlip_Slavutich_6")}</td>
                                <td>{i18next.t("PaySlip_Slavutich_8")}</td>
                                <td className="font-weight-bold">{level1Info.INN}</td>
                            </tr>
                            <tr>
                                <td>{i18next.t("PaySlip_Slavutich_9")}</td>
                                <td className="font-weight-bold">{level1Info.TabNum} {level1Info.Fio}</td>
                                <td className="text-left">{i18next.t("PaySlip_Slavutich_4")}</td>
                                <td colSpan="3" className="font-weight-bold">{level1Info.ProfName}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div className="ml-3 mt-1 mb-1">{i18next.t("PaySlip_Slavutich_5")}</div>
                </table>
            </div>
        )
    };

    renderReportInfo = (level1Info, level2Info) => {
        console.log(`level2Info: ${JSON.stringify(level2Info)}`);
        return (
            <>
                <table id="paySlip_main" cellPadding="3px" className="w-100">
                    <thead>
                    <tr>
                        <th className="w-50px">{this.getHeader("DbtMonth", "table")}</th>
                        <th className="w-50px">{this.getHeader("DbtTime", "table")}</th>
                        <th className="w-50px">{this.getHeader("DbtCode", "table")}</th>
                        <th>{this.getHeader("DbtName", "table")}</th>
                        <th>{this.getHeader("DbtSum", "table")}</th>
                        <th className="w-auto border-bottom-0"></th>
                        <th className="w-50px">{this.getHeader("CrdCode", "table")}</th>
                        <th>{this.getHeader("CrdName", "table")}</th>
                        <th>{this.getHeader("CrdSum", "table")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        level2Info.map((item, i) => (
                            <tr key={i}>
                                <td>{item.DbtMonth}</td>
                                <td>{item.DbtTime}</td>
                                <td>{item.DbtCode}</td>
                                <td className="text-left">{item.DbtName}</td>
                                <td>{this.getMoneyValue(item.DbtSum)}</td>
                                <td className="border-top-0 border-bottom-0"></td>
                                <td>{item.CrdCode}</td>
                                <td className="text-left">{item.CrdName}</td>
                                <td>{this.getMoneyValue(item.CrdSum)}</td>
                            </tr>
                        ))
                    }
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan="4"
                            className="text-right border-0 font-weight-bold">{this.getHeader("AllDbtSum")}:
                        </td>
                        <td className="w-auto border-0 font-weight-bold">{this.getMoneyValue(level1Info.AllDbtSum)}</td>
                        <td className="border-top-0 border-bottom-0"></td>
                        <td colSpan="2"
                            className="text-right border-0 font-weight-bold">{this.getHeader("AllCrdSum")}:
                        </td>
                        <td className="w-auto border-0 font-weight-bold">{this.getMoneyValue(level1Info.AllCrdSum)}</td>
                    </tr>
                    </tfoot>
                </table>

                {this.renderFooterInfo(level1Info)}
            </>
        );
    };

    renderFooterInfo = (level1Info) => {
        return (<>
                <table id="paySlip_SubFooter">
                    <tr>
                        <td></td>
                        <td>{this.getHeader("PercVal")}:</td>
                        <td className="paySlip_mn-report-value" width="100px">{this.getMoneyValue(level1Info.PercVal)}</td>
                    </tr>
                </table>
                <table id="paySlip_footer">
                    <tbody>
                    <tr>
                        <td>{this.getHeader("Cash")}:</td>
                        <td width="50px" className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.Cash)}</td>
                        <td width="50px" rowSpan="4" style={{borderTop: '0px', borderBottom: '0px'}}></td>
                        <td>{this.getHeader("BegSaldo")}:</td>
                        <td width="50px"
                            className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.BegSaldo)}</td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("Card")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.Card)}</td>

                        <td>{this.getHeader("EndSaldo")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.EndSaldo)}</td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("Bank")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.Bank)}</td>

                        <td>{this.getHeader("BegSaldoF")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.BegSaldoF)}</td>
                    </tr>
                    <tr>
                        <td>{this.getHeader("SumPNLgt")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.SumPNLgt)}</td>

                        <td>{this.getHeader("EndSaldoF")}:</td>
                        <td className="paySlip_mn-report-value">{this.getMoneyValue(level1Info.EndSaldoF)}</td>
                    </tr>
                    </tbody>
                </table>
            </>
        );
    }

    render() {
        if (this.props.headerDataItem.dataTable().length === 0) {
            return null;
        }

        let level1Info = this.props.headerDataItem.getRow(0);
        let level2Info = this.props.tableDataItem.dataTable();
/*
        let header = this.props.dataItem.dataTable().find(row => row.Level === 1);
        header.CalcMonthTxt = this.MonthName;
        header.CompName = this.props.myComp;
        const rows_L2 = this.props.dataItem.dataTable().filter(row => row.Level === 2);
        const rows_L3 = this.props.dataItem.dataTable().filter(row => row.Level === 3);
*/
        return (
            <div id="paySlip_report">
                <div>{level1Info.MyComp}</div>
                {this.renderHeaderInfo(level1Info)}
                {this.renderReportInfo(level1Info, level2Info)}
            </div>
        );
    }
}

PaySlipFormSlavutich.propTypes = {
    headerDataItem: PropTypes.object.isRequired,
    tableDataItem: PropTypes.object.isRequired,
    monthName: PropTypes.string,
    myComp: PropTypes.string
};

PaySlipFormSlavutich.defaultProps = {
    monthName: ""
};

export default PaySlipFormSlavutich;
